module.exports = __webpack_public_path__ + "img/trending-image-post-1.e583fe43.jpg";